import { MrbBaseListViewStore } from "mrb/core";
import { MrbTableViewStore } from "mrb/components";
import { mrbDefaultFormats } from "mrb/common/formatting";
import { applicationDefaults } from "common/constants";
import { localizationService } from "common/localization";

class AdminCertifiedModeListViewStore extends MrbBaseListViewStore {
    constructor(rootStore, { routeStore }) {
        super(rootStore, {
            layoutActions: {
                create: {
                    onClick: () => this.rootStore.routerStore.goTo("master.administration.certified-mode.create"),
                    label: "ADMINISTRATION.CERTIFIED_MODE.LIST.BUTTONS.ADD",
                },
            },
            queryConfig: {
                orderBy: "name",
                orderDirection: "asc",
                pageSize: 10,
            },
        });
        this.routeStore = routeStore;

        this.setGridStore(
            new MrbTableViewStore(this.rootStore, this.queryUtility, {
                onRowClick: (node) =>
                    this.rootStore.routerStore.goTo("master.administration.certified-mode.edit", {
                        id: node.data.id,
                    }),
                columns: [
                    {
                        key: "name",
                        title: "ADMINISTRATION.CERTIFIED_MODE.LIST.COLUMNS.NAME",
                        sortable: true,
                    },
                    {
                        key: "isActive",
                        title: "ADMINISTRATION.CERTIFIED_MODE.LIST.COLUMNS.STATUS",
                        sortable: true,
                        format: (value) =>
                            value
                                ? localizationService.t(
                                      "ADMINISTRATION.CERTIFIED_MODE.LIST.STATUS_ACTIVE"
                                )
                                : localizationService.t(
                                      "ADMINISTRATION.CERTIFIED_MODE.LIST.STATUS_INACTIVE"
                                  ),
                    },
                    {
                        key: "allowNonCertifiedContent",
                        title: "ADMINISTRATION.CERTIFIED_MODE.LIST.COLUMNS.ALLOW_NON_CERTIFIED_CONTENT",
                        sortable: true,
                        format: (value) =>
                            value
                                ? localizationService.t(
                                      "ADMINISTRATION.CERTIFIED_MODE.LIST.STATUS_ALLOWED"
                                )
                                : localizationService.t(
                                      "ADMINISTRATION.CERTIFIED_MODE.LIST.STATUS_RESTRICTED"
                                  ),
                    },
                    {
                        key: "dateCreated",
                        title: "ADMINISTRATION.CERTIFIED_MODE.LIST.COLUMNS.DATE_CREATED",
                        sortable: true,
                        format: {
                            type: mrbDefaultFormats.date,
                            format: applicationDefaults.formats.date,
                        },
                    },
                ],
                actions: {
                    delete: {
                        onClick: (item) =>
                            this.rootStore.confirmDialogStore.showConfirm({
                                message: "Do you want to delete Certified mode?",
                                onConfirm: async () => {
                                    try {
                                        await this.routeStore.deleteCertifiedMode(item);
                                        this.queryUtility.fetch();
                                    } catch (err) {
                                        this.rootStore.notificationStore.error(
                                            "An unexpected error occurred. Unable to delete Certified mode.",
                                            err
                                        );
                                    }
                                },
                                yesLabel: "Delete",
                                noLabel: "Cancel",
                                description: "You won't be able to revert this action.",
                            }),
                        label: "ADMINISTRATION.CERTIFIED_MODE.LIST.ACTIONS.DELETE",
                        buttonProps: {
                            className: "c-btn c-btn--sml c-btn--ghost",
                        },
                    },
                },
            })
        );
    }

    find(params) {
        return this.routeStore.findCertifiedModes(params);
    }

    onFetchError(err) {
        this.rootStore.notificationStore.error(
            "An unexpected error occurred while trying to load data. Please contact the support team.",
            err
        );
    }
}

export default AdminCertifiedModeListViewStore;
